import RecurringOrderSuggestionsModal from 'components/RecurringOrderSuggestionsModal/styled';

export default RecurringOrderSuggestionsModal;
